import { useEffect } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { FormText, FormTitle, WhatsLine } from "~/features/doctorForm/FormLayout";
import AppInvite from "~/features/doctorForm/AppInvite";
import { APP_INVITE, shouldInviteToApp } from "~/features/doctorForm/appInviteConfig";

// `channel` vem da resposta do POST (BE-1f): o convite ao app só para quem pediu pelo formulário (D24/D32).
const Step6 = ({ setDisabledNext, setActiveStep, mobile, channel }) => {
  useEffect(() => {
    setDisabledNext(true);
  }, [setDisabledNext]);
  return (
    <Box sx={{ textAlign: "center", py: mobile ? 2 : 4 }}>
      <Box sx={{ width: 88, height: 88, mx: "auto", borderRadius: "50%", bgcolor: "#e6f4ea", display: "grid", placeItems: "center" }}>
        <CheckCircleIcon sx={{ fontSize: 56, color: "#2e7d32" }} aria-hidden />
      </Box>
      <FormTitle mobile={mobile} sx={{ mt: 3, fontSize: mobile ? 22 : 28 }}>
        Solicitação enviada com sucesso!
      </FormTitle>
      <FormText sx={{ mt: 2, color: "text.secondary", maxWidth: 520, mx: "auto" }}>
        Sua solicitação foi enviada com sucesso e em breve nossa equipe entrará em contato.
      </FormText>
      <Box sx={{ maxWidth: 520, mx: "auto" }}>
        <WhatsLine center />
      </Box>
      {shouldInviteToApp(channel) && <AppInvite invite={APP_INVITE} mobile={mobile} />}
      <Button size="large" variant="contained" sx={{ mt: 4, textTransform: "none", fontWeight: 600 }} fullWidth={mobile} onClick={() => setActiveStep(0)}>
        Voltar para o inicio
      </Button>
    </Box>
  );
};

export default Step6;
